import React, { useState, useRef, useEffect } from 'react';
import { useListingSuggestCities } from '../../../../hooks/useListingSuggestCities';
import '../CityPicker/CityPicker.css';

const AsyncCityPicker = ({ value = '', handleChange }) => {
  const [query, setQuery] = useState(value);
  const inputEl = useRef(null);
  const [suggestedCities, setSearchTerm, setSuggestedCities] = useListingSuggestCities({
    url: '/city/destination',
    contextSearch: true,
  });

  useEffect(() => {
    inputEl.current.focus();
  }, []);
  const handleQuery = value => {
    const query = value;
    setQuery(query);
    setSearchTerm(query);
  };

  return (
    <div className="citypicker_container">
      <input
        ref={inputEl}
        placeholder="Enter City"
        className="citypicker_input"
        type="text"
        onChange={event => handleQuery(event.target.value)}
        value={query}
      />
      <div className="citypicker_list">
        <ul>
          {suggestedCities.map((city, index) => (
            <li key={index} onClick={() => handleChange(city)}>
              {city.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AsyncCityPicker;
